// enum based onpython class: https://git.rynekpierwotny.com/propertygroup/rp-auth/-/blob/master/python/apps/users/constants.py

export enum UserRegistrationSource {
    REGISTRATION = 1, // registration form/email
    REGISTRATION_GOOGLE_ONE_TAP_KM = 20, // Google One Tap in KM
    REGISTRATION_GOOGLE_ONE_TAP_RP = 21, // Google One Tap in RP
    REGISTRATION_FORM_GOOGLE = 22, // Google in registration form
    REGISTRATION_FORM_FACEBOOK = 23, // Facebook in registration form
    REGISTRATION_GH = 103, // registration form in KM/GetHome branded
    REGISTRATION_GH_FORM_GOOGLE = 105, // Google in registration form in KM/GetHome branded
    REGISTRATION_GH_FORM_FACEBOOK = 106, // Facebook in registration form in KM/GetHome branded
    REGISTRATION_GH_GOOGLE_ONE_TAP = 107 // Google One Tap in registration form in KM/GetHome branded
}
// enum based onpython class: https://git.rynekpierwotny.com/propertygroup/rp-auth/-/blob/master/python/apps/users/constants.py

export enum UserRegistrationSource {
    REGISTRATION = 1, // registration form/email
    REGISTRATION_GOOGLE_ONE_TAP_KM = 20, // Google One Tap in KM
    REGISTRATION_GOOGLE_ONE_TAP_RP = 21, // Google One Tap in RP
    REGISTRATION_FORM_GOOGLE = 22, // Google in registration form
    REGISTRATION_FORM_FACEBOOK = 23, // Facebook in registration form
    REGISTRATION_GH = 103, // registration form in KM/GetHome branded
    REGISTRATION_GH_FORM_GOOGLE = 105, // Google in registration form in KM/GetHome branded
    REGISTRATION_GH_FORM_FACEBOOK = 106, // Facebook in registration form in KM/GetHome branded
    REGISTRATION_GH_GOOGLE_ONE_TAP = 107 // Google One Tap in registration form in KM/GetHome branded
}
